// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { MintRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Mint';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';

const useMintRequests3Step: () => UseQueryResult<TemplateContract<MintRequest>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useQueryWithOffset({
    queryKey: ['queryMintRequests', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      return ledgerApi.queryMintRequests(offset, operator);
    },
  });
};

export default useMintRequests3Step;
